import { defineComponent as _defineComponent } from 'vue';
import * as Constants from '@/constants';
export default /*#__PURE__*/_defineComponent({
  __name: 'max-gap-option',
  props: {
    maxGaps: {
      default: Constants.Search.DefaultMaxGaps
    }
  },
  emits: ["update:max-gaps"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var DefaultMaxGaps = Constants.Search.DefaultMaxGaps;
    var NoMaxGaps = Constants.Search.NoMaxGaps;
    var maxGapsValue = computed({
      get: function get() {
        return props.maxGaps;
      },
      set: function set(newVal) {
        emit('update:max-gaps', newVal);
      }
    });
    return {
      __sfc: true,
      DefaultMaxGaps: DefaultMaxGaps,
      NoMaxGaps: NoMaxGaps,
      props: props,
      emit: emit,
      maxGapsValue: maxGapsValue
    };
  }
});